import DateUtils from 'src/utils/dateUtils';
import {
    ExecutionSelection,
    ListProducerRunsResponse,
    ProducerRun,
    SHARED_SELECTION,
} from 'src/models/common/ExecutionRun';

export { SHARED_SELECTION };
export type { ExecutionSelection };

export const CURRENT_NUMBERS_LABEL = 'Current numbers';

const RUN_TIME_FORMAT = 'YYYY/MM/DD hh:mm a z';
const SOURCE_LABEL: Record<ProducerRun['source'], string> = { MEC: 'Close', DRY_RUN: 'Dry run' };

export const isRunSelection = (selection?: ExecutionSelection): selection is { kind: 'RUN'; run: ProducerRun } =>
    selection?.kind === 'RUN';

/** The `executionId` read parameter: undefined for the shared numbers. */
export const toExecutionIdParam = (selection?: ExecutionSelection): string | undefined =>
    isRunSelection(selection) ? selection.run.executionId : undefined;

/** The server's default run, or the shared numbers when it names none (or one not in the list). */
export const defaultSelection = (response?: ListProducerRunsResponse | null): ExecutionSelection => {
    const run = (response?.runs ?? []).find((r) => r.executionId === response?.defaultExecutionId);
    return run ? { kind: 'RUN', run } : SHARED_SELECTION;
};

/** "Group 7 · Close · 2026/10/15 09:10 am PDT"; without a group number, "Close · <finish time>". */
export const runLabel = (run: ProducerRun): string => {
    const finished = DateUtils.formatDate(run.completedAt ?? run.startedAt, RUN_TIME_FORMAT);
    return [run.groupNumber ? `Group ${run.groupNumber}` : undefined, SOURCE_LABEL[run.source] ?? run.source, finished]
        .filter(Boolean)
        .join(' · ');
};
